/* InStrips 2026: open header dropdowns on hover (desktop, pointer devices).
   Refresh's menus are <details>/<summary>, which only toggle on click; touch
   devices keep the click behaviour untouched. */
(function () {
  if (!window.matchMedia || !window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
  var CLOSE_DELAY = 160;
  function wire(item) {
    var details = item.querySelector("details");
    if (!details || item.dataset.instripsHover) return;
    item.dataset.instripsHover = "1";
    var timer = null;
    item.addEventListener("mouseenter", function () {
      clearTimeout(timer);
      details.open = true;
      var summary = details.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", "true");
    });
    item.addEventListener("mouseleave", function () {
      timer = setTimeout(function () {
        details.open = false;
        var summary = details.querySelector("summary");
        if (summary) summary.setAttribute("aria-expanded", "false");
      }, CLOSE_DELAY);
    });
  }
  function init() {
    document.querySelectorAll(".header__inline-menu li, .header__menu-item-wrapper").forEach(wire);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();

/* Kaching Bundles: component names come from the Shopify product titles, so a
   three-box stack reads "… Buccal Strips" three times. Trim the format words
   inside the widget only; the titles themselves stay as they are. */
(function () {
  var SEL = ".kaching-bundles__bundle-products__title, .kaching-bundles__mix-and-match-product__title, .kaching-bundles__choose-multiple-gifts__product-title, .kaching-bundles__collection-product__title, .kaching-bundles__product-title, .kaching-bundles__bar-title, [class*='kaching-bundles__'][class*='product__title'], [class*='kaching-bundles__'][class*='product-title']";
  function trim(root) {
    (root || document).querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.instripsTrimmed === el.textContent) return;
      // Non-breaking hyphens inside compound names, so "TB-500" never splits across lines.
      var t = el.textContent.replace(/\s*Buccal Strips?\s*/i, " ").replace(/\s{2,}/g, " ").trim().replace(/(\w)-(\w)/g, "$1‑$2");
      if (t !== el.textContent) { el.textContent = t; }
      el.dataset.instripsTrimmed = el.textContent;
    });
  }
  function relabel(root) {
    (root || document).querySelectorAll(".kaching-bundles__bar-subtitle").forEach(function (el) {
      if (el.children.length) return;
      if (/^standard price$/i.test(el.textContent.trim())) el.textContent = "1 box · one-month supply";
    });
    // Stack-first pages: the auto-rendered quantity widget below the stack reads "Buy more & save".
    if (document.querySelector(".instrips-deal2--above")) (root || document).querySelectorAll(".kaching-bundles__block-title").forEach(function (el) {
      if (!el.closest(".instrips-deal2") && /^bundle & save$/i.test(el.textContent.trim())) el.textContent = "BUY MORE & SAVE";
    });
  }
  var mo = new MutationObserver(function () { trim(); relabel(); });
  function init() { trim(); relabel(); mo.observe(document.body, { childList: true, subtree: true, characterData: true }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* "Why a buccal strip" hero button: scroll to that section directly. The
   section's own id is generated by Shopify, so the link keeps a stable hash
   and this resolves it. Also honours a page load with the hash. */
(function () {
  function target() { return document.querySelector('.shopify-section[id$="__why_buccal"]'); }
  function go(e) {
    var t = target(); if (!t) return;
    if (e) e.preventDefault();
    var header = document.querySelector('.section-header, .shopify-section-group-header-group');
    var offset = header ? header.getBoundingClientRect().height : 0;
    window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - offset - 8, behavior: "smooth" });
    history.replaceState(null, "", "#why-buccal");
  }
  document.addEventListener("click", function (e) {
    var a = e.target.closest('a[href$="#why-buccal"]'); if (a) go(e);
  });
  if (location.hash === "#why-buccal") window.addEventListener("load", function () { setTimeout(go, 150); });
})();

/* Home line-up on phones: the row of boxes slides left as the page scrolls
   down, driving the container's own horizontal scroll. A clearly horizontal
   swipe hands control to the shopper (auto-pan stops); a vertical touch on the
   row leaves the auto-pan alone, so the page keeps scrolling normally. */
(function () {
  var mq = window.matchMedia("(max-width: 749px)");
  var wrap, img, ticking = false, programmatic = false, userTookOver = false;
  function update() {
    ticking = false;
    if (!wrap || !img || !mq.matches || userTookOver) return;
    var r = wrap.getBoundingClientRect(), vh = window.innerHeight;
    var progress = (vh - r.top) / (vh + r.height);
    progress = Math.max(0, Math.min(1, progress));
    progress = Math.max(0, (progress - 0.4) / 0.6);   // hold on BPC-157 while the band enters
    var travel = wrap.scrollWidth - wrap.clientWidth;
    programmatic = true;
    wrap.scrollLeft = travel * progress;
    requestAnimationFrame(function () { programmatic = false; });
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
  function init() {
    wrap = document.querySelector(".instrips-lineup"); img = wrap && wrap.querySelector("img");
    if (!img) return;
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    var sx = 0, sy = 0, decided = false;
    wrap.addEventListener("touchstart", function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; decided = false; }, { passive: true });
    wrap.addEventListener("touchmove", function (e) {
      if (decided) return;
      var dx = Math.abs(e.touches[0].clientX - sx), dy = Math.abs(e.touches[0].clientY - sy);
      if (dx < 8 && dy < 8) return;
      decided = true;
      if (dx > dy * 1.3) userTookOver = true;            // sideways swipe: shopper drives from here
    }, { passive: true });
    wrap.addEventListener("scroll", function () { if (!programmatic && !userTookOver) { /* momentum from a vertical gesture never lands here; ignore */ } }, { passive: true });
    if (img.complete) update(); else img.addEventListener("load", update);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* Subscription wording on product pages: the widget's own note says only the
   cadence and discount; add the cancel-anytime / self-service line and link
   the member portal. Also extends the widget's tooltip text when it appears. */
(function () {
  var NOTE = "Cancel anytime. Manage or pause it yourself in the member portal.";
  var PORTAL = "https://hub.instrips.com/subscription";
  function addNote() {
    var details = document.querySelector(".ks-subscription-details-text");
    if (!details || document.querySelector(".instrips-sub-note")) return;
    var host = details.closest("[class*=ks-subscription-details]") || details.parentElement;
    var p = document.createElement("p");
    p.className = "instrips-sub-note";
    p.innerHTML = NOTE.replace("member portal", '<a href="' + PORTAL + '">member portal</a>');
    host.insertAdjacentElement("afterend", p);
  }
  function extendTooltip() {
    document.querySelectorAll("[class*=ks-][class*=tooltip], [class*=ks-subscription-details]").forEach(function (el) {
      if (el.children.length || el.dataset.instripsNoted) return;
      if (/\d+% off\.?\s*$/.test(el.textContent) && !/Cancel anytime/.test(el.textContent)) {
        el.textContent = el.textContent.trim().replace(/\.?$/, ". ") + NOTE;
        el.dataset.instripsNoted = "1";
      }
    });
  }
  var mo = new MutationObserver(function () { addNote(); extendTooltip(); });
  function init() { addNote(); extendTooltip(); mo.observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* Bundle pages: the "What it is being studied for" bullets map one-to-one to
   the boxes, so dress each bullet with that box's thumbnail and ribbon colour
   (taken from the What's in the box list, same order). */
(function () {
  function init() {
    if (!document.querySelector(".product--bundle")) return;
    var items = document.querySelectorAll(".instrips-bundle__item");
    var h3 = [...document.querySelectorAll(".product__description.rte h3")].find(function (h) { return /studied for/i.test(h.textContent); });
    var ul = h3 && h3.nextElementSibling;
    if (!ul || ul.tagName !== "UL" || !items.length) return;
    var lis = ul.querySelectorAll("li");
    if (lis.length !== items.length) return;
    ul.classList.add("instrips-studied");
    lis.forEach(function (li, i) {
      var src = items[i].querySelector("img"), acc = items[i].style.getPropertyValue("--instrips-accent");
      var name = items[i].querySelector(".instrips-bundle__name");
      li.style.setProperty("--instrips-accent", acc);
      var text = li.innerHTML;
      li.innerHTML = '<span class="instrips-studied__media">' + (src ? '<img src="' + src.currentSrc + '" alt="" loading="lazy">' : "") + '</span>' +
        '<span class="instrips-studied__body">' + (name ? '<a class="instrips-studied__name" href="' + name.getAttribute("href") + '">' + name.textContent.trim() + '</a>' : "") + '<span class="instrips-studied__text">' + text + '</span></span>';
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* Lab testing lightbox: tapping a certificate thumbnail or "View certificate"
   shows the page render in an overlay instead of downloading the PDF. */
(function () {
  function init() {
    var box = document.querySelector(".instrips-lightbox"); if (!box) return;
    // Lift it out of the product section's stacking context so it covers the sticky header.
    if (box.parentElement !== document.body) document.body.appendChild(box);
    var img = box.querySelector("img"), cap = box.querySelector("figcaption");
    function open(src, title) { img.src = src; cap.textContent = title || ""; box.hidden = false; document.body.style.overflow = "hidden"; }
    function close() { box.hidden = true; img.removeAttribute("src"); document.body.style.overflow = ""; }
    document.addEventListener("click", function (e) {
      var t = e.target.closest("[data-coa-image]"); if (t) { e.preventDefault(); open(t.getAttribute("data-coa-image"), t.getAttribute("data-coa-title")); return; }
      if (e.target.closest(".instrips-lightbox__close") || (e.target === box)) close();
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !box.hidden) close(); });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();

/* Build-your-own stack page: our own picker in front of a hidden Kaching
   mix-and-match deal. One-time: the chosen strips are added with Kaching's own
   line-item properties so its tier discount (2 strips 10%, 3 strips 15%,
   4+ 18%) applies in cart and checkout. Subscribe: each strip's monthly
   selling plan (20% off) is attached instead and the deal properties are
   left off, so the two discounts never stack. */
(function () {
  var root = document.querySelector(".instrips-build"); if (!root) return;
  var tiers = root.dataset.tiers.split(",").map(function (t) { var p = t.split(":"); return { min: +p[0], pct: +p[1] }; });
  var SUB = +root.dataset.subPct || 20, SUBSTACK = +root.dataset.subStackPct || SUB;
  var cards = [].slice.call(root.querySelectorAll(".instrips-build__card"));
  var lines = root.querySelector(".instrips-build__lines"), empty = root.querySelector(".instrips-build__empty");
  var totals = root.querySelector(".instrips-build__totals"), submit = root.querySelector(".instrips-build__submit");
  var nudge = root.querySelector(".instrips-build__nudge"), subnote = root.querySelector(".instrips-build__subnote");
  var qty = {}, editing = false, existingKeys = [];
  function mode() { var r = root.querySelector('input[name=instrips-build-mode]:checked'); return r ? r.value : "once"; }
  function money(c) { return "$" + (c / 100).toFixed(2); }
  function tierFor(n) { var t = null; tiers.forEach(function (x) { if (n >= x.min) t = x; }); return t; }
  function nextTier(n) { for (var i = 0; i < tiers.length; i++) if (tiers[i].min > n) return tiers[i]; return null; }
  function kaching(which) {
    var sel = which === "sub" ? ".instrips-build__kaching--sub" : ".instrips-build__kaching:not(.instrips-build__kaching--sub)";
    var inp = root.querySelector(sel + ' input[name="properties[__kaching_bundles]"]');
    var radioEls = [].slice.call(root.querySelectorAll(sel + ' input[type=radio]'));
    if (!inp && radioEls[0]) { radioEls[0].click(); inp = root.querySelector(sel + ' input[name="properties[__kaching_bundles]"]'); }
    var radios = radioEls.map(function (r) { return r.value; });
    if (!inp || radios.length < 4) return null;
    try { var j = JSON.parse(inp.value); return { deal: j.deal, v: j.v, bars: radios }; } catch (e) { return null; }
  }
  var planLoads = {};
  function loadPlans() {
    cards.forEach(function (c) {
      if (c.dataset.plan || planLoads[c.dataset.handle]) return;
      planLoads[c.dataset.handle] = fetch("/products/" + c.dataset.handle + ".js").then(function (r) { return r.json(); }).then(function (pj) {
        var v = (pj.variants || []).filter(function (x) { return String(x.id) === c.dataset.variant; })[0] || pj.variants[0];
        var a = v && v.selling_plan_allocations && v.selling_plan_allocations[0];
        c.dataset.planChecked = "1";
        if (a) { c.dataset.plan = a.selling_plan_id; c.dataset.planPrice = a.price; }
        render();
      }).catch(function () { c.dataset.planChecked = "1"; });
    });
    return Promise.all(Object.keys(planLoads).map(function (k) { return planLoads[k]; }));
  }
  function unitPrice(c, pct, sub) {
    if (sub) return Math.round(+c.dataset.price * (100 - pct) / 100);
    return Math.round(+c.dataset.price * (100 - pct) / 100);
  }
  function render() {
    var sub = mode() === "sub", n = 0, before = 0, total = 0; lines.innerHTML = "";
    cards.forEach(function (c) { var q = qty[c.dataset.product] || 0; c.classList.toggle("is-picked", q > 0); c.querySelector("output").value = q; n += q; before += q * +c.dataset.price; });
    var t = tierFor(n), pct = sub ? (n >= 2 ? SUBSTACK : SUB) : (t ? t.pct : 0);
    cards.forEach(function (c) {
      var q = qty[c.dataset.product] || 0; if (!q) return;
      var each = unitPrice(c, pct, sub); total += q * each;
      var li = document.createElement("li"); li.style.setProperty("--instrips-accent", c.style.getPropertyValue("--instrips-accent"));
      var flag = sub && c.dataset.planChecked && !c.dataset.plan ? " <small>(one-time only)</small>" : "";
      li.innerHTML = "<span>" + c.dataset.title + (q > 1 ? " ×" + q : "") + flag + "</span><span>" + (each < +c.dataset.price ? "<s>" + money(q * +c.dataset.price) + "</s>" : "") + money(q * each) + "</span>";
      lines.appendChild(li);
    });
    root.querySelectorAll(".instrips-build__tiers li").forEach(function (li) { li.classList.toggle("is-active", sub ? li.dataset.tier === "sub" : (!!t && +li.dataset.tier === t.min)); });
    subnote.hidden = !sub;
    var noPlan = sub ? cards.filter(function (c) { return (qty[c.dataset.product] || 0) > 0 && c.dataset.planChecked && !c.dataset.plan; }).map(function (c) { return c.dataset.title; }) : [];
    var ready = (sub ? n >= 1 : n >= 2) && !noPlan.length;
    empty.hidden = ready; totals.hidden = !ready;
    var nudgeSub = sub && n === 1;
    if (!ready && noPlan.length) empty.textContent = noPlan.join(", ") + (noPlan.length > 1 ? " aren’t" : " isn’t") + " available on subscription yet. Remove " + (noPlan.length > 1 ? "them" : "it") + " or switch to one-time.";
    else if (!ready) empty.textContent = n === 1 ? "Add one more box to unlock 10% off. Any 3 save 15%, any 4 or more save 18%." : "Add any 2 boxes to unlock 10% off. Any 3 save 15%, any 4 or more save 18%.";
    totals.querySelector("[data-count]").textContent = n;
    totals.querySelector("[data-tier]").textContent = pct + (sub ? "% off, monthly" : "% off every box");
    totals.querySelector("[data-before]").textContent = money(before);
    totals.querySelector("[data-total]").textContent = money(total);
    var nt = !sub && n >= 1 ? nextTier(n) : null;
    if (nt) {
      var more = nt.min - n, extra = Math.round(before * (nt.pct - pct) / 100);
      nudge.textContent = "Add " + more + " more box" + (more > 1 ? "es" : "") + " to unlock " + nt.pct + "% off your whole stack" + (n >= 2 ? " — about " + money(extra) + " more saved on what's already in it." : ".");
      nudge.hidden = false;
    } else if (nudgeSub) { nudge.textContent = "Add one more box and the whole subscription drops to " + SUBSTACK + "% off."; nudge.hidden = false; }
    else nudge.hidden = true;
    submit.disabled = !ready;
    submit.textContent = !ready ? "Add stack to cart" : (editing ? "Update stack" : sub ? "Subscribe & save" : "Add stack to cart");
  }
  // The hidden widgets only write their property input once a bar is selected; pre-select the first bar as soon as each renders.
  var primed = 0, primeTimer = setInterval(function () {
    root.querySelectorAll(".instrips-build__kaching").forEach(function (f) {
      if (f.dataset.primed) return;
      var r = f.querySelector("input[type=radio]"); if (!r) return;
      r.click(); f.dataset.primed = "1"; primed++;
    });
    if (primed >= root.querySelectorAll(".instrips-build__kaching").length || primed > 40) clearInterval(primeTimer);
  }, 500);
  root.addEventListener("change", function (e) { if (e.target.name === "instrips-build-mode") { if (mode() === "sub") loadPlans(); render(); } });
  root.addEventListener("click", function (e) {
    var c = e.target.closest(".instrips-build__card"); if (!c) return;
    var id = c.dataset.product;
    if (e.target.closest(".instrips-build__add, .instrips-build__inc")) qty[id] = (qty[id] || 0) + 1;
    else if (e.target.closest(".instrips-build__dec")) qty[id] = Math.max(0, (qty[id] || 0) - 1);
    else return;
    render();
  });
  submit.addEventListener("click", function () {
    if (mode() === "sub" && cards.some(function (c) { return (qty[c.dataset.product] || 0) > 0 && !c.dataset.planChecked; })) { submit.disabled = true; submit.textContent = "Checking plans…"; loadPlans().then(function () { render(); if (!submit.disabled) submit.click(); }); return; }
    var sub = mode() === "sub", n = 0; cards.forEach(function (c) { n += qty[c.dataset.product] || 0; });
    var k = kaching(sub && n >= 2 ? "sub" : "once");
    if (sub ? n < 1 : n < 2) return;
    var bid = k ? k.bars[Math.min(n, 4) - 1] : null, bag = "b" + Math.random().toString(36).slice(2, 6);
    var items = [], main = true;
    cards.forEach(function (c) {
      var q = qty[c.dataset.product] || 0; if (!q) return;
      var it = { id: +c.dataset.variant, quantity: q };
      if (sub && c.dataset.plan) it.selling_plan = +c.dataset.plan;
      if (k && (!sub || n >= 2)) {
        it.properties = { __kaching_bundles: JSON.stringify(main ? { deal: k.deal, pp: +c.dataset.product, main: true, v: k.v, id: bag, bid: bid } : { id: bag, deal: k.deal, v: k.v, collectionBreaksProduct: true }) };
        main = false;
      }
      items.push(it);
    });
    submit.disabled = true; submit.textContent = editing ? "Updating…" : "Adding…";
    var rootUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/");
    var removeOld = existingKeys.length ? fetch(rootUrl + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ updates: existingKeys.reduce(function (o, k) { o[k] = 0; return o; }, {}) }) }).catch(function () {}) : Promise.resolve();
    removeOld.then(function () { return fetch(rootUrl + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items, sections: "cart-drawer,cart-icon-bubble" }) })
      .then(function (r) { return r.json(); }); })
      .then(function (res) {
        existingKeys = []; editing = false;
        var drawer = document.querySelector("cart-drawer");
        if (drawer && res.sections && typeof drawer.renderContents === "function") drawer.renderContents(res);
        else if (!document.querySelector("kaching-cart-drawer")) { window.location.href = "/cart"; return; }
        qty = {}; render();
      })
      .catch(function () { window.location.href = "/cart"; });
  });
  // ?stack=handle,handle,… (Sally's in-chat builder): start with those boxes picked.
  (function () {
    var want = (new URLSearchParams(location.search).get("stack") || "").split(",").filter(Boolean);
    if (!want.length) return;
    want.forEach(function (h) { var c = cards.filter(function (x) { return x.dataset.handle === h; })[0]; if (c) qty[c.dataset.product] = (qty[c.dataset.product] || 0) + 1; });
    render();
    setTimeout(function () { (totals.hidden ? empty : totals).scrollIntoView({ behavior: "smooth", block: "center" }); }, 300);
  })();
  // Prefill from a stack already in the cart (lines carrying either builder deal), so coming back edits it in place.
  function prefill() {
    var ids = [kaching("once"), kaching("sub")].filter(Boolean).map(function (k) { return k.deal; });
    if (!ids.length) return;
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) {
      var found = false, sub = false;
      (c.items || []).forEach(function (it) {
        var raw = it.properties && it.properties.__kaching_bundles; if (!raw) return;
        var j; try { j = JSON.parse(raw); } catch (e) { return; }
        if (ids.indexOf(j.deal) < 0) return;
        var card = cards.filter(function (x) { return +x.dataset.product === it.product_id; })[0]; if (!card) return;
        qty[card.dataset.product] = (qty[card.dataset.product] || 0) + it.quantity; existingKeys.push(it.key); found = true;
        if (it.selling_plan_allocation) sub = true;
      });
      if (!found) return;
      editing = true;
      var r = root.querySelector('input[name=instrips-build-mode][value=' + (sub ? "sub" : "once") + ']'); if (r) r.checked = true;
      if (sub) loadPlans();
      render();
    }).catch(function () {});
  }
  var prefillTries = 0, prefillTimer = setInterval(function () {
    prefillTries++;
    var forms = root.querySelectorAll(".instrips-build__kaching");
    var ready = forms.length && [].every.call(forms, function (f) { return f.querySelector("input[type=radio]"); });
    if (ready) { clearInterval(prefillTimer); kaching("once"); kaching("sub"); setTimeout(prefill, 1200); }
    else if (prefillTries > 60) clearInterval(prefillTimer);
  }, 400);
  render();
})();

/* Product pages: mount the "other" Kaching deal under the buy button. Kaching
   auto-renders one deal per product; this reads the deal settings it prints,
   picks the deal of the other kind (quantity breaks vs. suggested stack) and
   mounts it as a pinned widget with its own add-to-cart. */
(function () {
  var host = document.querySelector(".instrips-deal2"); if (!host) return;
  var tries = 0;
  var timer = setInterval(function () {
    tries++;
    var auto = document.querySelector('.product__info-container .kaching-bundles__block, product-info .kaching-bundles__block, .kaching-bundles__block');
    if (!auto && tries < 40) return;
    clearInterval(timer);
    var deals = [].slice.call(document.querySelectorAll("script.kaching-bundles-deal-block-settings")).map(function (s) { try { return JSON.parse(s.textContent); } catch (e) { return null; } }).filter(Boolean);
    var isStack = function (d) { return (d.dealBars || []).some(function (b) { return b.dealBarType === "bundle"; }); };
    var isQty = function (d) { return !d.collectionBreaksEnabled && (d.dealBars || []).length && (d.dealBars || []).every(function (b) { return b.dealBarType === "quantity-break"; }); };
    var autoId = auto ? auto.dataset.dealBlockId : null;
    var autoDeal = deals.filter(function (d) { return d.id === autoId; })[0];
    var want = autoDeal && isStack(autoDeal) ? deals.filter(isQty)[0] : deals.filter(isStack)[0];
    if (!want || (autoDeal && want.id === autoDeal.id)) return;
    var stack = isStack(want);
    host.querySelector(".instrips-deal2__h").textContent = stack ? "Suggested stack" : "Buy more & save";
    host.classList.toggle("instrips-deal2--stack", stack);
    if (stack && auto) {
      // Stack first, quantity breaks below: move the mount above the auto-rendered widget and relabel that one.
      // Mount above Kaching's outermost element (its custom element re-renders and would wipe anything inside it).
      var top = auto.closest("kaching-bundle") || auto.closest(".kaching-bundles") || auto;
      while (top.parentElement && top.parentElement.children.length === 1 && !top.parentElement.classList.contains("product__info-container")) top = top.parentElement;
      top.parentNode.insertBefore(host, top);
      host.classList.add("instrips-deal2--above");
      var t = auto.querySelector(".kaching-bundles__block-title"); if (t && /bundle/i.test(t.textContent)) t.textContent = "BUY MORE & SAVE";
    }
    var f = document.createElement("form"); f.action = host.dataset.cartUrl || "/cart/add"; f.method = "post"; f.className = "instrips-deal2__form";
    f.innerHTML = '<kaching-bundle product-id="' + host.dataset.productId + '" manual-deal-block-id="' + want.id + '"></kaching-bundle><button type="submit" class="product-form__submit button button--full-width button--primary instrips-deal2__btn">' + "Add to cart" + "</button>";
    host.querySelector(".instrips-deal2__mount").appendChild(f);
    host.hidden = false;
  }, 250);
})();

/* Shipping note sits directly above the Add to cart button (inside the product form, below Kaching widgets). */
(function () {
  function place() {
    var note = document.querySelector(".instrips-shipnote"), btns = document.querySelector(".product-form__buttons");
    if (note && btns && note.nextElementSibling !== btns) btns.parentNode.insertBefore(note, btns);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", place); else place();
  setTimeout(place, 1500); setTimeout(place, 4000);
})();

/* Share with a friend: device share sheet when available, otherwise copy the link and confirm. */
(function () {
  document.addEventListener("click", function (e) {
    var btn = e.target.closest(".instrips-share__btn"); if (!btn) return;
    var url = btn.dataset.url, text = btn.querySelector(".instrips-share__btn-text");
    function done(label) {
      btn.classList.add("is-copied"); text.textContent = label;
      var toast = document.createElement("div"); toast.className = "instrips-toast"; toast.textContent = "Link copied — paste it anywhere to share"; document.body.appendChild(toast);
      requestAnimationFrame(function () { toast.classList.add("is-on"); });
      setTimeout(function () { btn.classList.remove("is-copied"); text.textContent = "Share with a friend"; toast.classList.remove("is-on"); setTimeout(function () { toast.remove(); }, 300); }, 2600);
    }
    var touch = window.matchMedia("(hover: none) and (pointer: coarse)").matches;
    if (navigator.share && touch) { navigator.share({ title: btn.dataset.title, text: btn.dataset.text, url: url }).catch(function () {}); return; }
    function legacy() { var ta = document.createElement("textarea"); ta.value = url; ta.setAttribute("readonly", ""); ta.style.cssText = "position:fixed;top:0;left:0;opacity:0;"; document.body.appendChild(ta); ta.select(); ta.setSelectionRange(0, url.length); var ok = false; try { ok = document.execCommand("copy"); } catch (x) {} ta.remove(); if (ok) done("Link copied!"); else { btn.classList.add("is-copied"); text.textContent = url; } }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(function () { done("Link copied!"); }).catch(legacy); else legacy();
  });
})();


/* Free samples: with three different boxes in the cart the shopper picks up to
   three sample strips (two strips each, $0 variants of the hidden "Free samples"
   product). Tile grid of box photos, mounted in the Kaching cart drawer and on
   the cart page. Samples are removed again if the cart drops below three
   different boxes. Variant ids / images come from #instrips-samples-data. */
(function () {
  var SAMPLE_HANDLE = "free-sample-strips", NEED = 3, MAX = 3;
  var BOXES = ["restore-peptide-blend", "recharge-nad-buccal-strips", "dsip-buccal-strips", "ghk-cu-buccal-strips", "cjc1295-ipamorelin-buccal-strips", "mots-c-buccal-strips", "retatrutide-buccal-strips", "semax-selank-buccal-strips", "ta1-buccal-strips", "pt-141-oxytocin-buccal-strips"];
  var HANDLE_OF = { "BPC-157 / TB-500": "restore-peptide-blend", "NAD+": "recharge-nad-buccal-strips", "DSIP": "dsip-buccal-strips", "GHK-Cu": "ghk-cu-buccal-strips", "CJC-1295 / Ipamorelin": "cjc1295-ipamorelin-buccal-strips", "MOTS-c": "mots-c-buccal-strips", "RT3": "retatrutide-buccal-strips", "Semax / Selank": "semax-selank-buccal-strips", "Thymosin Alpha-1": "ta1-buccal-strips", "PT-141 / Oxytocin": "pt-141-oxytocin-buccal-strips" };
  var GIFT = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v10H4V12"/><path d="M2 7h20v5H2z"/><path d="M12 22V7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg>';
  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>';
  var data = null, bundles = {}, BOXDATA = [], busy = false, pin = null;
  // Kaching mix-and-match deal ("Build your stack", 2:10% 3:15% 4+:18%). Kaching only discounts
  // lines carrying this property, so every one-time single box in the cart gets stamped with it.
  var DEAL = { short: "SjYg", v: "95d895be-2273-4498-9eca-cdcaafeb71ce" };
  var TIERS = { 2: 10, 3: 15, 4: 18 };
  function tierPct(n) { return n >= 4 ? TIERS[4] : (TIERS[n] || 0); }
  function money(c) { return "$" + (c / 100).toFixed(2).replace(/.00$/, ""); }
  function groupId(items) {
    for (var i = 0; i < items.length; i++) { try { var k = JSON.parse(items[i].properties && items[i].properties.__kaching_bundles || "null"); if (k && k.collectionBreaksProduct && k.deal === DEAL.short) return k.id; } catch (e) {} }
    return "qadd1";
  }
  function dealProp(items) { return { __kaching_bundles: JSON.stringify({ id: groupId(items), deal: DEAL.short, v: DEAL.v, collectionBreaksProduct: true }) }; }
  try { var el = document.getElementById("instrips-samples-data"); if (el) data = JSON.parse(el.textContent); } catch (e) {}
  try { var bx = document.getElementById("instrips-boxes-data"); if (bx) BOXDATA = JSON.parse(bx.textContent) || []; } catch (e) {}
  try { var bl = document.getElementById("instrips-bundles-data"); if (bl) bundles = JSON.parse(bl.textContent) || {}; } catch (e) {}
  if (data) data = data.filter(function (v) { return v.name !== "RT3"; });
  if (!data || !data.length) return;
  function root() { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : "/"); }
  function hosts() {
    var out = [];
    var drawer = document.querySelector("kaching-cart-drawer .kaching-cart__footer"); if (drawer) out.push({ el: drawer, where: "prepend" });
    var page = document.querySelector(".cart__footer, #main-cart-footer"); if (page) out.push({ el: page, where: "prepend" });
    return out;
  }
  function post(path, body) {
    return fetch(root() + path, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) });
  }
  function shortName(n) { return n.replace("Thymosin Alpha-1", "TA-1").replace("CJC-1295 / Ipamorelin", "CJC / Ipa").replace("PT-141 / Oxytocin", "PT-141").replace("Semax / Selank", "Semax").replace("BPC-157 / TB-500", "BPC-157"); }
  function render(cart) {
    var items = cart.items || [];
    var samples = items.filter(function (i) { return i.handle === SAMPLE_HANDLE; });
    var boxes = {}; items.forEach(function (i) {
      if (BOXES.indexOf(i.handle) > -1) boxes[i.handle] = 1;
      (bundles[i.handle] || []).forEach(function (h) { boxes[h] = 1; });
    });
    var distinct = Object.keys(boxes).length;
    var hasSub = items.some(function (i) { return !!i.selling_plan_allocation && i.handle !== SAMPLE_HANDLE; });
    var unlocked = distinct >= NEED || hasSub;
    var fix = {};
    var owned = function (name) { return !!boxes[HANDLE_OF[name]]; };
    var kept = 0;
    samples.forEach(function (s) { if (!unlocked || owned(s.variant_title) || kept >= MAX) fix[s.key] = 0; else { kept++; if (s.quantity > 1) fix[s.key] = 1; } });
    if (Object.keys(fix).length) { busy = true; return post("cart/update.js", { updates: fix }).then(function () { busy = false; refresh(); }, function () { busy = false; }); }
    var bare = items.filter(function (i) { return BOXES.indexOf(i.handle) > -1 && !(i.properties && i.properties.__kaching_bundles) && !i.selling_plan_allocation; })[0];
    if (bare) { busy = true; return post("cart/change.js", { id: bare.key, quantity: bare.quantity, properties: dealProp(items) }).then(function () { busy = false; refresh(); }, function () { busy = false; }); }
    // stale sample lines (added before the Strips property existed) get it stamped on
    var stale = samples.filter(function (s) { return !(s.properties && s.properties.Strips); })[0];
    if (stale) { busy = true; return post("cart/change.js", { id: stale.key, quantity: 1, properties: { Strips: "2", _free_sample: "yes" } }).then(function () { busy = false; refresh(); }, function () { busy = false; }); }
    var picked = {}; samples.forEach(function (s) { picked[s.variant_id] = s.key; });
    var n = Object.keys(picked).length, remaining = NEED - distinct;
    var key = JSON.stringify([Object.keys(boxes).sort(), Object.keys(picked).sort(), hasSub]);
    hosts().forEach(function (h) {
      var box = h.el.querySelector(":scope > .instrips-samples");
      if (!box) { box = document.createElement("div"); box.className = "instrips-samples kaching-cart__module"; box.dataset.key = ""; if (h.where === "prepend") h.el.prepend(box); else h.el.appendChild(box); }
      if (box.dataset.key === key) return; box.dataset.key = key;
      box.classList.toggle("instrips-samples--locked", !unlocked);
      var dots = ""; for (var d = 0; d < MAX; d++) dots += "<i" + (d < n ? ' class="is-on"' : "") + "></i>";
      var html = '<div class="instrips-samples__top"><span class="instrips-samples__gift">' + GIFT + "</span><div>" +
        '<p class="instrips-samples__title">' + (unlocked ? (n ? n + " of " + MAX + " free samples chosen" : "Choose " + MAX + " free samples") : MAX + " free samples") + "</p>" +
        '<p class="instrips-samples__sub">' + (unlocked ? (n >= MAX ? "All set. Tap one to swap it out." : (hasSub && distinct < NEED ? "A subscriber perk: two strips of each, on us. Tap to add." : "Try something new: two strips of each, on us. Tap to add.")) : (MAX * 2) + " free strips when you order " + NEED + " different boxes.") + "</p>" +
        '</div><span class="instrips-samples__dots" aria-hidden="true">' + dots + "</span></div>";
      if (!unlocked) html += '<p class="instrips-samples__lock">' + LOCK + "<span>Add " + remaining + " more different box" + (remaining > 1 ? "es" : "") + " to unlock, or subscribe to any box.</span></p>";
      html += '<div class="instrips-samples__grid">' + data.filter(function (v) { return !owned(v.name); }).sort(function (a, b) { return (picked[b.id] ? 1 : 0) - (picked[a.id] ? 1 : 0); }).map(function (v) {
        var on = !!picked[v.id], off = !on && n >= MAX;
        return '<button type="button" class="instrips-samples__tile' + (on ? " is-on" : "") + (off ? " is-off" : "") + '" data-variant="' + v.id + '"' + (picked[v.id] ? ' data-key="' + picked[v.id] + '"' : "") + ' style="--acc:' + v.acc + '"' + (off ? " disabled" : "") + ' aria-pressed="' + on + '" title="' + v.name + '">' +
          (v.img ? '<img src="' + v.img + '" alt="" loading="lazy">' : '<span class="instrips-samples__ph"></span>') +
          '<span class="instrips-samples__nm">' + shortName(v.name) + '</span><span class="instrips-samples__ct">2 strips</span></button>';
      }).join("") + "</div>";
      box.innerHTML = html;
    });
    renderBoxes(boxes, distinct, unlocked, remaining, items);
    enhanceUpgrade(items, !unlocked);
  }
  // Kaching's "Subscribe and save" toggle on one-time lines → explicit upgrade offer with the saving
  function enhanceUpgrade(items, locked) {
    document.querySelectorAll("kaching-cart-drawer .kaching-cart-item[data-has-selling-plan=\"false\"]").forEach(function (li) {
      var btn = li.querySelector(".kaching-cart-item__selling-plan-upgrade"); if (!btn || btn.dataset.instrips) return;
      var key = li.getAttribute("data-line-key"); var line = null; items.forEach(function (i) { if (i.key === key) line = i; }); if (!line) return;
      var pct = bundles[line.handle] ? 25 : (BOXES.indexOf(line.handle) > -1 ? 20 : 0); if (!pct) return;
      var monthly = Math.round(line.original_price * (100 - pct) / 100);
      btn.dataset.instrips = "1"; btn.classList.add("instrips-upg");
      var label = btn.querySelector("span"); if (label) label.textContent = "Subscribe";
      var save = document.createElement("span"); save.className = "instrips-upg__save"; save.textContent = "Save " + pct + "% · " + money(monthly) + "/mo"; btn.title = "Upgrade this box to a monthly subscription"; btn.appendChild(save);
    });
  }
  function renderBoxes(inCart, distinct, unlocked, remaining, items) {
    var elig = {}; items.forEach(function (i) { if (BOXES.indexOf(i.handle) > -1 && !i.selling_plan_allocation) elig[i.handle] = 1; });
    // A stack in the cart unlocks the Shopify automatic discount "15% off boxes added to a stack"
    // (one product discount per line, best wins), so the next box gets at least 15%.
    var hasStack = items.some(function (i) { return !!bundles[i.handle]; });
    var nextPct = Math.max(tierPct(Object.keys(elig).length + 1), hasStack ? 15 : 0);
    var host = document.querySelector("kaching-cart-drawer .kaching-cart__contents"); if (!host || !BOXDATA.length) return;
    var row = host.querySelector(":scope > .instrips-boxes");
    if (!row) { row = document.createElement("div"); row.className = "instrips-boxes kaching-cart__module"; row.dataset.key = ""; host.appendChild(row); }
    var list = BOXDATA.filter(function (b) { return !inCart[b.handle]; });
    var key = JSON.stringify([distinct, nextPct, list.map(function (b) { return b.handle; })]);
    if (row.dataset.key === key) return; row.dataset.key = key;
    if (!list.length) { row.innerHTML = ""; return; }
    var head = unlocked ? "Add another box" : "Add " + remaining + " more box" + (remaining > 1 ? "es" : "") + " to unlock " + MAX + " free samples";
    var sub = unlocked ? "Every box is a one-month supply." : "Any " + remaining + " different compound" + (remaining > 1 ? "s" : "") + " will do. Subscribers get samples right away.";
    var html = '<div class="instrips-boxes__top"><p class="instrips-boxes__title">' + head + '</p><p class="instrips-boxes__sub">' + sub + "</p></div>";
    html += '<div class="instrips-boxes__row">' + list.map(function (b) {
      return '<div class="instrips-boxes__card" style="--acc:' + b.acc + '"><span class="instrips-boxes__media">' + (b.img ? '<img src="' + b.img + '" alt="" loading="lazy">' : "") + "</span>" +
        '<span class="instrips-boxes__name">' + b.name + "</span>" + (nextPct ? '<span class="instrips-boxes__price"><s>' + b.price + "</s> <strong>" + money(Math.round(b.cents * (100 - nextPct) / 100)) + "</strong></span>" + '<span class="instrips-boxes__off">' + nextPct + "% off in your cart</span>" : '<span class="instrips-boxes__price">' + b.price + "</span>") +
        '<button type="button" class="instrips-boxes__add" data-variant="' + b.id + '">Add</button></div>';
    }).join("") + "</div>";
    row.innerHTML = html;
    if (pin && Date.now() < pin.until) {
      var rr = row.querySelector(".instrips-boxes__row"); if (rr) rr.scrollLeft = pin.x;
      var keep = function () { host.scrollTop = host.scrollHeight; if (rr) rr.scrollLeft = pin.x; };
      keep(); requestAnimationFrame(keep); setTimeout(keep, 150); setTimeout(keep, 400);
    }
  }
  function refresh() {
    if (busy) return;
    fetch(root() + "cart.js").then(function (r) { return r.json(); }).then(render).catch(function () {});
  }
  document.addEventListener("click", function (e) {
    // The whole card adds the box (not just its button).
    var card = e.target.closest(".instrips-boxes__card");
    var add = e.target.closest(".instrips-boxes__add") || (card && card.querySelector(".instrips-boxes__add:not(:disabled)"));
    if (add && !busy) { busy = true; add.disabled = true; add.textContent = "Adding…"; var rowEl = add.closest(".instrips-boxes__row"); pin = { x: rowEl ? rowEl.scrollLeft : 0, until: Date.now() + 6000 }; fetch(root() + "cart.js").then(function (r) { return r.json(); }).then(function (c) { return post("cart/add.js", { items: [{ id: +add.dataset.variant, quantity: 1, properties: dealProp(c.items || []) }] }); }).then(function () { busy = false; refresh(); document.dispatchEvent(new CustomEvent("instrips:cart-changed")); }, function () { busy = false; add.disabled = false; add.textContent = "Add"; }); return; }
    var tile = e.target.closest(".instrips-samples__tile"); if (!tile || tile.disabled || busy) return;
    busy = true; tile.classList.toggle("is-on");
    var done = function () { busy = false; refresh(); };
    if (tile.dataset.key) post("cart/change.js", { id: tile.dataset.key, quantity: 0 }).then(done, done);
    else post("cart/add.js", { items: [{ id: +tile.dataset.variant, quantity: 1, properties: { Strips: "2", _free_sample: "yes" } }] }).then(done, done);
  });
  var mo = new MutationObserver(function () {
    var d = document.querySelector("kaching-cart-drawer .kaching-cart__footer");
    var cont = document.querySelector("kaching-cart-drawer .kaching-cart__contents");
    if ((d && !d.querySelector(":scope > .instrips-samples")) || (cont && !cont.querySelector(":scope > .instrips-boxes"))) refresh();
  });
  // On open, land on the add-boxes row (bottom of the scroll area) instead of the header banner.
  var wasOpen = false;
  function toBottom() { var h = document.querySelector("kaching-cart-drawer .kaching-cart__contents"); if (h) h.scrollTop = h.scrollHeight; }
  function watchOpen() {
    var d = document.querySelector("kaching-cart-drawer"); var open = !!(d && d.getAttribute("open") === "true" && d.getBoundingClientRect().width > 0);
    if (open && !wasOpen) { refresh(); [120, 350, 700].forEach(function (t) { setTimeout(toBottom, t); }); }
    wasOpen = open;
  }
  // Product page: Kaching subscription card gets a "+ 3 free samples" row with box thumbnails
  function decorateSubCard() {
    document.querySelectorAll(".kaching-subscriptions__card-wrapper").forEach(function (w) {
      if (w.querySelector(".instrips-subperk") || !/subscribe/i.test((w.querySelector(".kaching-subscriptions__card-title") || {}).textContent || "")) return;
      var host = w.querySelector(".kaching-subscriptions__selling-plans-wrapper") || w.querySelector(".kaching-subscriptions__card"); if (!host) return;
      var pics = BOXDATA.filter(function (b) { return b.img && b.handle !== (window.location.pathname.split("/products/")[1] || "").split(/[?#]/)[0]; }).slice(0, 5);
      var row = document.createElement("div"); row.className = "instrips-subperk";
      row.innerHTML = '<span class="instrips-subperk__gift">' + GIFT + "</span>" +
        '<span class="instrips-subperk__text"><strong>+ ' + MAX + " FREE samples</strong> with your first box · pick any " + MAX + " compounds in your cart</span>" +
        '<span class="instrips-subperk__pics">' + pics.map(function (b) { return '<img src="' + b.img + '" alt="" loading="lazy">'; }).join("") + "</span>";
      host.appendChild(row);
    });
  }
  function init() { setInterval(decorateSubCard, 800); decorateSubCard(); mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ["open"] }); refresh(); setInterval(refresh, 4000); setInterval(watchOpen, 150); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
